import { render, staticRenderFns } from "./CompanyDesktopOrdered.vue?vue&type=template&id=7f0430fc"
import script from "./CompanyDesktopOrdered.vue?vue&type=script&lang=js"
export * from "./CompanyDesktopOrdered.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports